<template>
  <a-row :gutter="16" class="summary-cards">
    <a-col :span="6">
      <a-card :loading="loading" class="summary-card">
        <div class="card-label">订单总额</div>
        <div class="card-value">
          <Balance :amount="summary?.totalAmount || 0"/>
          <a-tag v-if="summary?.amountRatio != null" :color="summary.amountRatio >= 0 ? 'green' : 'red'">
            {{ summary.amountRatio >= 0 ? '↑' : '↓' }} {{ Math.abs(summary.amountRatio || 0) }}%
          </a-tag>
        </div>
        <div class="card-sub">{{ summary?.totalCount || 0 }} 笔</div>
      </a-card>
    </a-col>

    <a-col :span="6">
      <a-card :loading="loading" class="summary-card">
        <div class="card-label">服务费收入</div>
        <div class="card-value">
          <Balance :amount="summary?.totalServiceFee || 0"/>
          <a-tag v-if="summary?.serviceFeeRatio != null" :color="summary.serviceFeeRatio >= 0 ? 'green' : 'red'">
            {{ summary.serviceFeeRatio >= 0 ? '↑' : '↓' }} {{ Math.abs(summary.serviceFeeRatio || 0) }}%
          </a-tag>
        </div>
        <div class="card-sub">{{ summary?.serviceFeeCount || 0 }} 笔</div>
      </a-card>
    </a-col>

    <a-col :span="6">
      <a-card :loading="loading" class="summary-card">
        <div class="card-label">分润支出</div>
        <div class="card-value">
          <Balance :amount="summary?.totalProfitShare || 0"/>
          <a-tag v-if="summary?.profitShareRatio != null" :color="summary.profitShareRatio >= 0 ? 'green' : 'red'">
            {{ summary.profitShareRatio >= 0 ? '↑' : '↓' }} {{ Math.abs(summary.profitShareRatio || 0) }}%
          </a-tag>
        </div>
        <div class="card-sub">{{ summary?.profitShareCount || 0 }} 笔</div>
      </a-card>
    </a-col>

    <a-col :span="6">
      <a-card :loading="loading" class="summary-card">
        <div class="card-label">商户数</div>
        <div class="card-value">
          <span class="number">{{ summary?.merchantCount || 0 }}</span>
        </div>
        <div class="card-sub">
          活跃 {{ summary?.activeMerchantCount || 0 }} 家
        </div>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import Balance from '@/view/components/Balance.vue';

export default {
  name: 'GlobalSummaryCards',
  components: {Balance},
  props: {
    summary: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.summary-cards {
  margin-bottom: 16px;
}

.summary-card {
  background: linear-gradient(135deg, #ffffff 0%, #f5f7fa 100%);
  border: 1px solid #e8e8e8;

  .card-label {
    font-size: 14px;
    color: #666;
    margin-bottom: 8px;
  }

  .card-value {
    font-size: 20px;
    font-weight: 600;
    color: #262626;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .number {
      font-size: 28px;
      color: #1890ff;
    }
  }

  .card-sub {
    margin-top: 8px;
    font-size: 12px;
    color: #999;
  }
}
</style>